import { useMemo, useState } from "react";

const VARIANT_STYLES = {
  salon: {
    accent: "#c9a890",
    bgFrom: "#f7efe6",
    bgTo: "#f1d5c6",
  },
  hairdresser: {
    accent: "#b89a86",
    bgFrom: "#f6efe9",
    bgTo: "#edd7c9",
  },
  generic: {
    accent: "#c9a890",
    bgFrom: "#f7efe6",
    bgTo: "#f1d5c6",
  },
};

function escapeXml(value) {
  return String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&apos;");
}

function buildFallbackSvg({ title, subtitle, accent, bgFrom, bgTo }) {
  const safeTitle = escapeXml(title);
  const safeSubtitle = escapeXml(subtitle);
  return `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 240" role="img" aria-label="${safeTitle}">
      <defs>
        <linearGradient id="bg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="${bgFrom}" />
          <stop offset="100%" stop-color="${bgTo}" />
        </linearGradient>
      </defs>
      <rect width="320" height="240" rx="24" fill="url(#bg)" />
      <circle cx="70" cy="70" r="44" fill="${accent}" fill-opacity="0.35" />
      <circle cx="250" cy="180" r="62" fill="${accent}" fill-opacity="0.18" />
      <rect x="28" y="142" width="264" height="70" rx="16" fill="#ffffff" fill-opacity="0.75" />
      <text x="44" y="176" font-family="Fira Sans, Arial, sans-serif" font-size="20" fill="#2d221b" font-weight="600">
        ${safeTitle}
      </text>
      <text x="44" y="198" font-family="Fira Sans, Arial, sans-serif" font-size="12" fill="#6f5d51">
        ${safeSubtitle}
      </text>
    </svg>
  `;
}

function buildFallbackUrl({ label, variant }) {
  const style = VARIANT_STYLES[variant] || VARIANT_STYLES.generic;
  const title = label || "Imagem";
  const subtitle = "Imagem de referencia";
  const svg = buildFallbackSvg({
    title,
    subtitle,
    accent: style.accent,
    bgFrom: style.bgFrom,
    bgTo: style.bgTo,
  });
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}

export default function ImageWithFallback({ src, alt, label, variant = "generic", className }) {
  const [hasError, setHasError] = useState(false);
  const fallback = useMemo(() => buildFallbackUrl({ label, variant }), [label, variant]);
  const resolvedSrc = src && !hasError ? src : fallback;

  return (
    <img
      src={resolvedSrc}
      alt={alt || label || "Imagem"}
      className={className}
      loading="lazy"
      decoding="async"
      onError={() => {
        if (!hasError) setHasError(true);
      }}
    />
  );
}
